module.exports = __webpack_public_path__ + "static/media/mapbox-icon-static.c0cf546c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mapbox-icon-static.svg
// module id = 185
// module chunks = 0